export default {
      id: "settings-light-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#settings-light",
      toString: function () {
        return this.url;
      }
    }